"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CreatorBase_1 = __importDefault(require("./CreatorBase"));
const generated_1 = require("../generated");
class CqlRetrieveCreator extends CreatorBase_1.default {
    constructor(ctx) {
        super(ctx, {});
    }
    build() {
        this.cqlDao.name = this.findChildText(generated_1.cqlLexer.QUOTEDIDENTIFIER);
        this.cqlDao.terminology = this.findChildText(generated_1.cqlLexer.QUOTEDIDENTIFIER, 2);
        this.cqlDao.hits = 0;
        return this.cqlDao;
    }
}
exports.default = CqlRetrieveCreator;
//# sourceMappingURL=CqlRetrieveCreator.js.map